module.exports = {
  IMAGE_MODE: {
    ANIMATION: "animation",
    ONMOVE: "onMove",
    STATIC: "static"
  }
};